import { error } from "../Error";
import { setCredentialsCookies } from "../../Utils/cookies";
import http from "../HTTP/HttpService";
import path from "../path";

export async function register(body) {
  const { result, response } = await http.POST(`${path.domain}${path.auth.register}`, body);

  if (!response.ok) {
    return error("Error signing up user", result.error, response.status);
  }

  setCredentialsCookies(response);

  return {
    id: result.body.id,
    username: result.body.username,
  };
}

export async function login(body) {
  const { result, response } = await http.POST(`${path.domain}${path.auth.login}`, body);

  if (!response.ok) {
    return error("Error logging in user", result.error, response.status);
  }

  setCredentialsCookies(response);

  return {
    id: result.body.id,
    username: result.body.username,
  };
}

export async function logout() {
  const { result, response } = await http.GET(`${path.domain}${path.auth.logout}`);

  if (!response.ok) {
    return error("Error logging out user", result.error, response.status);
  }
}

export async function validateUsername(username) {
  const { result, response } = await http.GET(`${path.domain}${path.auth.validateUsername}/${username}`);

  if (!response.ok) {
    if (response.status === 409) {
      return error("Username is not available", result.error, response.status);
    }

    return error("Error logging out user", result.error, response.status);
  }

  return true;
}

export async function refreshToken() {
  const { result, response } = await http.GET(`${path.domain}${path.auth.refreshToken}`);

  if (!response.ok) {
    return error("Unable to validate refresh token", result.error, response.status);
  }

  return true;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  login,
  logout,
  register,
  refreshToken,
  validateUsername,
};
